export default __webpack_public_path__ + "static/media/3132 cutlery top.9e636858.png";